// Tiny dev-only logger. Stripped in production builds so we don't leak
// stack traces or noisy console output to end users. Use everywhere instead
// of bare `console.error()`.
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logWarn = (...args) => {
  if (isDev) console.warn(...args);
};
